import Toast from 'bootstrap/js/dist/toast';
import { dayjs } from '../../components/dayjs-localized';
import Cookies from 'js-cookie';
import bsModal from 'bootstrap/js/dist/modal';
import { yieldToMain } from '../../components/helpers';

const NotificationManager = {
  storageNotificationSubscribeClosedKey: 'subscribeNotificationClosedDate',
  refreshPage: false,
  cookieKey: 'pushNotificationSubscriptionUpdate',
  get notificationSubscribeClosedDate() {
    return localStorage.getItem(this.storageNotificationSubscribeClosedKey);
  },
  /**
   * @param date {string}
   */
  set notificationSubscribeClosedDate(date) {
    localStorage.setItem(this.storageNotificationSubscribeClosedKey, date);
  },
  init() {
    const isIncompatible = this.showIncompatibleMessage();
    if (isIncompatible) {
      return;
    }
    if (navigator.serviceWorker) {
      // we add an interval to wait for the window.serviceWorkerRegistration to be defined before doing anything else
      const startTime = Date.now();
      const interval = setInterval(() => {
        const elapsedTime = Date.now() - startTime;

        // in case the setInterval loops on itself and does not stop, we stop it after 15secs
        if (elapsedTime > 15000) {
          clearInterval(interval);
        }

        if (window.serviceWorkerRegistration !== undefined) {
          clearInterval(interval);

          if (Notification.permission === 'granted') {
            this.updateSubscription();
          }

          this.showNotificationSubscription();
        }
      }, 200);
    }
  },
  requestPermission() {
    const that = this;
    if (!('Notification' in window)) {
      console.error('This browser does not support desktop notification');

      // Let's check whether notification permissions have already been granted
    } else if (Notification.permission === 'granted') {
      that.registerUserWebPush();

      // Otherwise, we need to ask the user for permission
    } else if (Notification.permission !== 'denied') {
      Notification
        .requestPermission()
        .then(
          (permission) => {
          // If the user accepts, let's create a notification
            if (permission === 'granted') {
              that.registerUserWebPush();
            }
          }
        );
    }
  },
  showDeniedNotificationMessage() {
    $('.push-notification-blocked').show();

    $('.reset-notification-btn').click(() => {
      bsModal.getOrCreateInstance(document.getElementById('reset-notification-explanation')).show();
    });
  },
  /**
   * serviceWorkerRegistration is initialized in the serviceworker companion and is accessible through window
   */
  registerUserWebPush() {
    const that = this;
    window.serviceWorkerRegistration
      .pushManager
      .getSubscription()
      .then(
        (subscription) => {
          if (subscription) {
            return subscription;
          }

          return window.serviceWorkerRegistration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: window.vapidPublicKey,
          });
        }
      ).then(
        function(subscription) {
          $.post('/push_notification_subscriptions', {
            subscription: subscription.toJSON(),
            refreshPage: that.refreshPage,
          });
        }
      );
  },
  showNotificationSubscription() {
    if (Notification.permission === 'granted') {
      return;
    }

    if (Notification.permission === 'denied') {
      this.showDeniedNotificationMessage();
      return;
    }

    const that = this;
    let toast = null;

    $('.push-notification-not-subscribed').show();

    if (Notification.permission !== 'granted' &&
        (!that.notificationSubscribeClosedDate ||
            dayjs(that.notificationSubscribeClosedDate).add(12, 'M').isBefore(dayjs())
        )
    ) {
      // We use the toast module of bootstrap to show the subscription to the notification globally
      const toastElement = document.getElementById('notification-subscribe');
      if (toastElement) {
        toast = new Toast(toastElement, { autohide: false });
        toast.show();

        toastElement.addEventListener('hidden.bs.toast', () => {
          that.notificationSubscribeClosedDate = dayjs().format();
        });
      }
    }

    // Get subscription through a click
    $('.notification-subscribe-btn').click((e) => {
      if (e.target.dataset.refresh === 'true') {
        that.refreshPage = true;
      }
      that.requestPermission();
      $('.push-notification-not-subscribed').hide();
      if (toast !== null) {
        toast.hide();
      }
    });
  },
  showIncompatibleMessage() {
    if (!('Notification' in window)) {
      $('.push-notification-incompatible').show();
      return true;
    }
    return false;
  },
  /**
   * We create a cookie that expires in 48h so that we can ensure that the information
   * of the subscription stays up to date every two days
   */
  updateSubscription() {
    if (!Cookies.get(this.cookieKey)) {
      Cookies.set(this.cookieKey, 'true', { expires: 1 });
      window.serviceWorkerRegistration
        .pushManager
        .getSubscription()
        .then((subscription) => {
          if (subscription) {
            $.ajax({
              type: 'PATCH',
              url: '/push_notification_subscriptions/update_subscription',
              data: {
                subscription: subscription.toJSON(),
              },
            });
          }
        });
    }
  },
};

document.addEventListener('turbo:load', async function() {
  // Yield to the main thread:
  await yieldToMain();
  NotificationManager.init();
});
